// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

type MutationOptions = {
  variables: {
    input: {
      poUploadId: string,
      matchedData: Object,
    },
  },
};

const mutation = graphql`
  mutation ConfirmPOExtractionMutation($input: ConfirmPOExtractionInput!) {
    confirmPOExtraction(input: $input) {
      poUpload {
        poUploadId
        status
        orderId
      }
      orderEdge {
        node {
          id
        }
      }
    }
  }
`;

export default {
  commit: (options: MutationOptions) => {
    return createRelayMutation(mutation, options);
  },
};
